/**
 * Warnings for BPMN Standard Loop steps (bpmn:StandardLoopCharacteristics).
 * Enforces that a step with a loop attached either has a cancel condition
 * or a positive max iterations safeguard — otherwise it will run forever.
 */

const { is } = require("bpmnlint-utils");

const LOOP_STD_CONDITION_KEY = "loop.standard.condition";
const LOOP_STD_MAX_KEY = "loop.standard.max";

function isStandardLoop(node) {
  const bo = node && (node.businessObject || node);
  if (!bo) return false;

  const lc = bo.loopCharacteristics;
  return !!lc && lc.$type === "bpmn:StandardLoopCharacteristics";
}

function readJsonFromExtra(step, key) {
  if (!step || typeof step !== "object") return undefined;

  const extra = Array.isArray(step.extraParameters) ? step.extraParameters : [];
  const hit = extra.find((p) => p && (p.key === key || p.Key === key));

  const raw = hit && (hit.value ?? hit.Value);
  if (!raw || typeof raw !== "string") return undefined;

  try {
    return JSON.parse(raw);
  } catch {
    return undefined;
  }
}

function hasMeaningfulCondition(cond) {
  if (!cond || typeof cond !== "object") return false;

  if (cond.field1 || cond.Field1) return true;

  const set = cond.conditionSet || cond.ConditionSet;
  if (set) {
    const conditions = set.conditions || set.Conditions;
    if (Array.isArray(conditions) && conditions.length > 0) {
      return conditions.some((c) => hasMeaningfulCondition(c));
    }
  }
  return false;
}

module.exports = function loopConfig({ ctx }) {
  return {
    check(node, reporter) {
      if (!node) return;

      const isStepLike = is(node, "bpmn:Task") || is(node, "bpmn:UserTask");
      if (!isStepLike || !isStandardLoop(node)) return;

      const getWfSteps = ctx && typeof ctx.getWfSteps === "function" ? ctx.getWfSteps : null;
      const steps = getWfSteps ? getWfSteps() : null;
      if (!Array.isArray(steps) || steps.length === 0) return;

      const step = steps.find((s) => s && s.id === node.id);
      if (!step) return;

      const condition = readJsonFromExtra(step, LOOP_STD_CONDITION_KEY);
      const maxIterRaw = readJsonFromExtra(step, LOOP_STD_MAX_KEY);
      const maxIter = typeof maxIterRaw === "number" ? maxIterRaw : 0;

      const hasCondition = hasMeaningfulCondition(condition);

      if (!hasCondition && maxIter <= 0) {
        reporter.report(node.id, "Loop has no cancel condition and no max iterations. The step will run forever.");
        return;
      }

      if (!hasCondition) {
        reporter.report(node.id, "Loop has no cancel condition. It will only stop once max iterations is reached.");
        return;
      }

      if (maxIter <= 0) {
        reporter.report(
          node.id,
          "Loop has no max iterations safeguard. If the cancel condition is never met, the step will run forever."
        );
      }
    }
  };
};
